import LoginWA from './Login.WA';
import LoginLDAP from './Login.LDAP';
import LoginRU from './Login.RU';
import '../../../assets/Geogrotesque/geofrotesque.css';

export default LoginRU;